import type * as SpringRoll from "springroll";

export abstract class BaseCaptionRenderer extends PIXI.Container implements SpringRoll.IRender {
    protected _size!: PIXI.Point;

    protected templateVariables?: SpringRoll.TemplateVariables;

    public start(templateVariables: SpringRoll.TemplateVariables): void {
        // override
        this.templateVariables = templateVariables;
    }

    public stop(): void {
        // override
    }

    public lineBegin(pLine: SpringRoll.Timedline): void {
        // override
    }

    public lineEnd(): void {
        // override
    }

    public onResize(pSize: PIXI.Point): void {
        this._size = pSize;
    }
}
